export default "__VITE_ASSET__LNHuseE___"